import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import CheckoutPreview from '../CheckoutPreview/CheckoutPreview'
import SectionIntro from '../SectionIntro/SectionIntro'
import { declineActionStyleOptions } from './constants'
import * as Styles from './styles'

const CheckoutBlock = ({ appearance, onChange, disabled }) => {
  const { t } = useTranslation()

  const menuItems = declineActionStyleOptions.map(option => ({ label: t(option.label), value: option.value }))

  const handleDeclineActionStyleChange = event => onChange('decline_action_style', event.target.value)

  return (
    <Styles.Block>
      <SectionIntro
        title={t('Checkout')}
        description={t(
          'Controla cómo se muestran en el checkout de tu tienda las opciones junto al widget de Return Protection.'
        )}
      />
      <Styles.Content>
        <ComboBox
          label={t('Continuar sin Return Protection')}
          value={appearance.decline_action_style}
          menuItems={menuItems}
          handleChange={handleDeclineActionStyleChange}
          helperText={t(
            'Elige cómo se muestra esta opción junto al botón principal del checkout. Un enlace es menos visible.'
          )}
          disabled={disabled}
          fullWidth
        />
        <CheckoutPreview appearance={appearance} />
      </Styles.Content>
    </Styles.Block>
  )
}

export default CheckoutBlock
